export default __webpack_public_path__ + "static/media/plain-sticker-j.b5fc0077.png";